'use client';

import { useParams, usePathname } from 'next/navigation';
import { useSuspenseQuery } from '@apollo/client/react';
import { eventSeriesLayoutQuery } from '@/apollo/event-series';
import { extractId } from '@/utils/slugify';
import Main from '@/components/main';
import Header from '@/components/event-series/header';

type Props = {
  children: React.ReactNode;
};

const EventSeriesLayoutClient = ({ children }: Props) => {
  const { id: rawId } = useParams();
  const id = extractId(rawId as string);
  const pathname = usePathname();
  const { data } = useSuspenseQuery(eventSeriesLayoutQuery, {
    variables: { id },
  });

  const tab = pathname.endsWith('/schedule')
    ? 'schedule'
    : pathname.endsWith('/settings')
      ? 'settings'
      : 'overview';

  return (
    <Main compact>
      <Header eventSeries={data.eventSeries} tab={tab} />
      {children}
    </Main>
  );
};

export default EventSeriesLayoutClient;
